import { NBSP } from '../../../constants/symbols';

export const getSubtitle = (price?: string, isRegistered?: boolean) => {
  const priceString = price ? `Стоимость отчета ${price}.` : '';
  const registerString = !isRegistered
    ? `Чтобы провести оплату, нам нужно будет зарегистрировать вас на Циан. Мы не будем спамить и${NBSP}рассылать рекламу. `
    : '';

  return `
    ${registerString}
    ${priceString}
    Оплата пройдёт через сервис Юkassa, продавцом будет указан ООО${NBSP}«АЙРИЭЛТОР».
  `;
};
